<template>
  <div class="promo-product">
    <div class="promo-header">
      <div class="hero-shot-container">
        <img :src="product.photoSet.individual.smallUrl" class="hero-shot" />
      </div>
      <div class="product-name-container">
        <div class="product-name">{{product.name}}</div>
        <div v-if="product.collection" class="product-collection">{{product.collection}}</div>
        <div class="product-sku">{{product.sku}}</div>
      </div>
    </div>
    <div class="d-flex justify-start align-center" style="flex-wrap: wrap;">
      <div
        v-if="dealer.pricelists.length > 0 && dealer.pricelists[0]"
        class="mr-3"
        style="font-weight: bold; font-size: 24px;"
      >{{product.cells[dealer.pricelists[0].id].display}}</div>
      <v-dialog v-model="dialog" transition="dialog-bottom-transition" width="90vw">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on" class="mr-2 mb-2">
            <div>More</div>
            <v-icon class="ml-1">mdi-information-outline</v-icon>
          </v-btn>
        </template>
        <v-card height="90vh" width="90vw" class="card">
          <v-card-title class="grey lighten-2">{{product.name}}</v-card-title>
          <v-card-text class="dialog-body pa-0">
            <v-row class="fill-height" no-gutters>
              <v-col class="left-column" cols="8">
                <v-carousel height="100%" class="product-carousel" :show-arrows="false">
                  <v-carousel-item v-for="image in product.photoSet.all" :key="image.name">
                    <div class="fill-height d-flex justify-center align-center pa-3">
                      <img
                        :src="image.largeUrl"
                        style="max-height: 100%; max-width: 100%; width: auto; height: auto; cursor: pointer"
                        @click="zoomImage(image)"
                      />
                    </div>
                  </v-carousel-item>
                </v-carousel>
              </v-col>
              <v-col class="right-column" cols="4">
                <table class="info-table">
                  <tr v-for="column in theBackColumns" :key="column.id" class="info-row">
                    <td class="key">{{column.name}}:</td>
                    <td class="value">{{product.cells[column.id].display}}</td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="grey lighten-2">
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        :color="product.soldOut ? 'warning' : 'success'"
        @click="addItem()"
        :disabled="added"
        width="150"
        class="mb-2"
      >
        <div v-if="added" style="display: flex; justify-content: center; align-items: center;">
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          <div class="ml-1">Added</div>
        </div>
        <div v-else style="display: flex; justify-content: center; align-items: center;">
          <div>Add To Cart</div>
          <v-icon class="ml-1">mdi-cart-arrow-down</v-icon>
        </div>
      </v-btn>
    </div>
    <v-divider v-if="product.description" class="my-3"></v-divider>
    <div class="promo-description">{{product.description}}</div>
    <v-divider v-if="product.features.length > 0" class="my-3"></v-divider>
    <ul class="promo-features">
      <li v-for="(feature, index) in product.features" :key="index">{{feature}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    group: Object,
    product: Object,
    width: String
  },
  data: () => ({
    dialog: false,
    added: false
  }),
  computed: {
    theFrontColumns: function() {
      return this.config.frontColumns.filter(
        column => this.product.cells[column.id].display
      );
    },
    theBackColumns: function() {
      return this.config.backColumns.filter(
        column => this.product.cells[column.id].display
      );
    },
    slideshow: function() {
      return this.$store.state.slideshow;
    },
    dealer: function() {
      return this.$store.state.dealer;
    },
    config: function() {
      return this.$store.state.config;
    }
  },
  methods: {
    zoomImage: function(image) {
      this.$store.commit("zoomImage", image);
    },
    addItem: async function() {
      try {
        var id = await this.$store.dispatch("addItem2", {
          product: this.product,
          quantity: this.quantity || 1,
          group: this.group
        });

        if (this.product.configurable) {
          this.$router.push(
            `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Config/${id}`
          );
        }

        this.added = true;
        setTimeout(() => (this.added = false), 3000);
      } catch (error) {
        //alert(error);
        throw error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.promo-product {
  //border: 1px solid black;
  //padding: 5px;
  //background-color: white;
}

.promo-header {
  display: flex;
  padding-bottom: 10px;
}

.hero-shot-container {
  flex: none;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .hero-shot {
    max-height: 90px;
    max-width: 100%;
    height: auto;
    width: auto;
  }
}

.product-name-container {
  padding-left: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-weight: bold;
  font-size: 24px;
  color: black;
  display: flex;
}

.product-collection {
  font-size: 16px;
  color: gray;
}

.product-sku {
  font-size: 12px;
  color: gray;
}
</style>

<!--More Button-->
<style lang="scss" scoped>
.product-row {
  outline: 1px solid lightgray;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
}

.card {
  display: flex;
  flex-direction: column;

  .dialog-body {
    flex: 1;
    overflow: hidden;
  }
}

.left-column {
  height: 100%;
}

.right-column {
  height: 100%;
  overflow: auto;
}

.product-carousel {
  background-color: rgb(255, 255, 255);
  //box-shadow: inset 0px 0px 10px black;
}

.info-table {
  width: 100%;
  border-collapse: collapse;

  .info-row {
    &:not(:last-child) {
      border-bottom: 1px solid rgb(200, 200, 200);
    }

    &:nth-child(even) {
      background-color: rgb(240, 240, 240);
    }

    td {
      padding: 5px;
    }
    .key {
      font-weight: bold;
    }
    .value {
      text-align: right;
    }
  }
}
</style>
